import { HttpClient, HttpErrorResponse, HttpEvent, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlMaker } from 'src/app/commons/url-maker';
import { environment } from 'src/environments/environment';
import { catchError } from 'rxjs/operators';
import { Observable, Subscription, throwError } from 'rxjs';
import { authService, TbAuthService } from '@tb/auth';
import { ProductRelease } from 'src/app/model/ProductRelease';
import { NewOperationResult } from './operation-result-new';
import { ProductDownloadReq } from 'src/app/model/product-download-req';
import { ImprovementAnalisys, ProjectImprovementReleases } from 'src/app/model/ProjectImprovementReleases';
import pdfMake from 'pdfmake/build/pdfmake';
import { ProjectBugReleases } from 'src/app/model/ProjectBugReleases';
import { LoginService } from './login.service';
import { ArchiviedDocumentInfo } from 'src/app/model/ArchiviedDocumentInfo';
import { CmsService } from './cms.service';
import { WorkFlowService } from './work-flow.service';
import { ProjectDataType } from 'src/app/model/customer';
import { PaiIncident } from 'src/app/model/PaiIncident';
import { AdministrativeInfo, AdministrativeInfoContainer } from 'src/app/model/AdministrativeInfo';
import { CustomerService } from './customer.service';

@Injectable({
    providedIn: 'root',
})
export class ProductDownloadService {
    storeApiUrl: string;
    proxyApiUrl: string;
    public administrativeInfo: Subscription;
    public isPlatinumPartner: boolean = false;

    constructor(private http: HttpClient, private tbAuthService: TbAuthService, private loginService: LoginService, private cmsService: CmsService, private workFlow: WorkFlowService, private customerService: CustomerService) {
        this.storeApiUrl = environment.settings.storeApiUrl;
        this.proxyApiUrl = environment.settings.microareaserviceproxy;
    }


    public setPlatinumPartner(productCode: string){
        this.administrativeInfo = this.customerService.companyInfo$.subscribe((companyInfo) => {
            if (!companyInfo) return;
            this.isPlatinumPartner = AdministrativeInfoContainer.isPlatinumPartner(
                this.customerService.ListOfMandati,
                productCode
            );
        });
    }

    private async getDisclaimer(): Promise<string>{
        try {
            let cmsObj = await this.cmsService.getCmsObj(this.workFlow.getLanguageForCms(), 'bugsReportReleseNotes');
            return cmsObj.find((x) => x.ContentName == 'bugsReportReleseNotes.Disclaimer').ContentTranslation;
        }
        catch {
            return ""
        }
    }

    /*public async getCompanyInfoByCompanyCOde(companyCode: string): Promise<Object> {
      let url = new UrlMaker()
        .appendBaseUrl(this.proxyApiUrl)
        .appendSegment('getFamilyProductReleases')
        .appendSegment(this.tbAuthService.getAccountName())
    }*/

    //let familyProductsRes = await this.productDownloadService.getProductReleases(this.productDto.Family,null,null,null,null,false,!this.isPlatinumPartner);
    public async getProductReleases(family: string, productCode?: string, release?: string, aCountry?: string, resellerCode?: string, searchDirectProduct: boolean = false, noDevelopment: boolean = false) : Promise<NewOperationResult<ProductRelease[]>>  {
        let url = new UrlMaker()
            .appendBaseUrl(this.storeApiUrl)
            .appendSegment('getFamilyProductReleases')
            .appendSegment(this.tbAuthService.getAccountName())

        if(productCode) url.appendParameter("productCode", productCode)
        if(release) url.appendParameter("release", release)
        if(family) url.appendParameter("family", family)
        if(searchDirectProduct) url.appendParameter("searchDirectProduct", searchDirectProduct)
        if(noDevelopment) url.appendParameter("noDevelopment", noDevelopment)

        url.toString()

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const reqBody = {
          "authToken": environment.auth.authToken
        }

        const bodyString = JSON.stringify(reqBody);
        return this.http
        .post<NewOperationResult<ProductRelease[]>>(url.toString(), bodyString, { headers })
        .pipe(catchError((error: HttpErrorResponse) => throwError(error || 'Server error in getTopReleaseForDownload')))
        .toPromise();
    }

    public async getProductReleasesForKnowledge(productCode?: string) : Promise<NewOperationResult<ProductRelease[]>>  {
        let url = new UrlMaker()
            .appendBaseUrl(this.storeApiUrl)
            .appendSegment('getProductReleasesForKnowledge')
            .appendSegment(this.tbAuthService.getAccountName())

        if(productCode) url.appendParameter("productCode", productCode)
        url.toString()
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const reqBody = {
            "authToken": environment.auth.authToken
        }

        const bodyString = JSON.stringify(reqBody);
        return this.http
        .post<NewOperationResult<ProductRelease[]>>(url.toString(), bodyString, { headers })
        .pipe(catchError((error: HttpErrorResponse) => throwError(error || 'Server error in getProductReleasesForKnowledge')))
        .toPromise();
    }

    public async getProductImprovements(productCode: string = "", release: string = "", projectImprID: number = 0, searchString: string = "") : Promise<NewOperationResult<ProjectImprovementReleases[]>>  {
        let url = new UrlMaker()
            .appendBaseUrl(this.storeApiUrl)
            .appendSegment('getProjectImprovementReleases')
            .appendSegment(this.tbAuthService.getAccountName())
            .appendParameter("productCode", productCode)
            .appendParameter("release", release)
            .appendParameter("projectImprID", projectImprID)
            .appendParameter("searchString", searchString)
            .toString()

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const reqBody = {
            "authToken": environment.auth.authToken,
        }

        const bodyString = JSON.stringify(reqBody);
        return this.http
        .post<NewOperationResult<ProjectImprovementReleases[]>>(url.toString(), bodyString, { headers })
        .pipe(catchError((error: HttpErrorResponse) => throwError(error || 'Server error in getProjectImprovementReleases')))
        .toPromise();
    }

    public async getProductBugs(productCode: string, release: string = "", searchString: string = "") : Promise<NewOperationResult<ProjectBugReleases[]>>  {
        let url = new UrlMaker()
            .appendBaseUrl(this.storeApiUrl)
            .appendSegment('getProjectBugReleases')
            .appendSegment(this.tbAuthService.getAccountName())
            .appendParameter("productCode", productCode)
            .appendParameter("release", release)
            .appendParameter("searchString", searchString)
            .toString()

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        const reqBody = {
            "authToken": environment.auth.authToken,
        }

        const bodyString = JSON.stringify(reqBody);

        return this.http
        .post<NewOperationResult<ProjectBugReleases[]>>(url.toString(), reqBody, { headers })
        .pipe(catchError((error: HttpErrorResponse) => throwError(error || 'Server error in getProjectBugs')))
        .toPromise();
    }

    public async getIncidents(productCode: string, release: string = "", searchString: string = "") : Promise<NewOperationResult<PaiIncident[]>>  {
        let url = new UrlMaker()
            .appendBaseUrl(this.storeApiUrl)
            .appendSegment('getIncidents')
            .appendSegment(this.tbAuthService.getAccountName())
            .appendParameter("productCode", productCode)
            .appendParameter("release", release)
            .appendParameter("searchString", searchString)
            .toString()

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        const reqBody = {
            "authToken": environment.auth.authToken,
        }

        const bodyString = JSON.stringify(reqBody);

        return this.http
        .post<NewOperationResult<PaiIncident[]>>(url.toString(), reqBody, { headers })
        .pipe(catchError((error: HttpErrorResponse) => throwError(error || 'Server error in getIncidents')))
        .toPromise();
    }

    public downloadProduct(reqBody: ProductDownloadReq, language: string = '', isPlatinumPartner: boolean): Observable<HttpEvent<Blob>> {
        let authorization = {
            type: "jwt",
            appId: "ST",
            securityValue: this.loginService.getAuthInfoProperties().jwtEncoded
        }
        const headers = new HttpHeaders({ 'Authorization': JSON.stringify(authorization) });
        let url = new UrlMaker()
            .appendBaseUrl(this.proxyApiUrl)
            .appendSegment('api')
            .appendSegment('downloadProduct')
            .appendSegment(this.tbAuthService.getAccountName())
            .appendParameter('productCode', reqBody.productCode)
            .appendParameter('releaseNr', reqBody.releaseNr)
            .appendParameter('language', language)
            .appendParameter('isDeveloper', isPlatinumPartner)
            .toString();
        return this.http.request(new HttpRequest( 'GET', url, null, { reportProgress: true, responseType: 'blob', headers: headers }));
    }

    public CheckDownloadProduct(reqBody: ProductDownloadReq, language: string = ''): Promise<NewOperationResult<string>> {
        let authorization = {
            type: "jwt",
            appId: "ST",
            securityValue: this.loginService.getAuthInfoProperties().jwtEncoded
        }

        const headers = new HttpHeaders({ 'Authorization': JSON.stringify(authorization) });
        let url = new UrlMaker()
            .appendBaseUrl(this.proxyApiUrl)
            .appendSegment('api')
            .appendSegment('downloadProduct')
            .appendSegment(this.tbAuthService.getAccountName())
            .appendParameter('productCode', reqBody.productCode)
            .appendParameter('releaseNr', reqBody.releaseNr)
            .appendParameter('language', language)
            .toString();

        return this.http
            .post<NewOperationResult<string>>(url.toString(), reqBody, { headers })
            .pipe(catchError((error: HttpErrorResponse) => throwError(error || 'Server error in setNotFoundedProducts')))
            .toPromise();
    }

    public async setNotFoundedProducts(productCode: string, release: string) : Promise<NewOperationResult<boolean>> {
        let url = new UrlMaker()
            .appendBaseUrl(this.storeApiUrl)
            .appendSegment('insertNotFoundedRelease')
            .appendSegment(this.tbAuthService.getAccountName())
            .appendParameter("productCode", productCode)
            .appendParameter("release", release)
            .toString()

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        const reqBody = {
            "authToken": environment.auth.authToken,
        }

        const bodyString = JSON.stringify(reqBody);

        return this.http
        .post<NewOperationResult<boolean>>(url.toString(), reqBody, { headers })
        .pipe(catchError((error: HttpErrorResponse) => throwError(error || 'Server error in setNotFoundedProducts')))
        .toPromise();
    }

    public async downloadInfo(productCode: string, release: string, ok: boolean) : Promise<Object> {
        let url = new UrlMaker()
            .appendBaseUrl(this.storeApiUrl)
            .appendSegment('downloadInfo')
            .appendSegment(this.tbAuthService.getAccountName())
            .appendParameter("productCode", productCode)
            .appendParameter("release", release)
            .appendParameter("ok", ok)
            .toString()

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        const reqBody = {
            "authToken": environment.auth.authToken,
        }

        const bodyString = JSON.stringify(reqBody);

        return this.http
        .post<NewOperationResult<boolean>>(url.toString(), reqBody, { headers })
        .pipe(catchError((error: HttpErrorResponse) => throwError(error || 'Server error in downloadInfo')))
        .toPromise();
    }

    public async getProjectArchiviedDocument(projImprID: number, type: string) : Promise<NewOperationResult<ArchiviedDocumentInfo[]>>  {
        let url = new UrlMaker()
            .appendBaseUrl(this.proxyApiUrl)
            .appendSegment('api')
            .appendSegment('getProjectArchiviedDocumentInfo')
            .appendParameter("projImprId", projImprID)
            .appendParameter("type", type)
            .toString()

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        const reqBody = {
            "authToken": environment.auth.authToken,
        }

        const bodyString = JSON.stringify(reqBody);

        return this.http
        .post<NewOperationResult<ArchiviedDocumentInfo[]>>(url.toString(), reqBody, { headers })
        .pipe(catchError((error: HttpErrorResponse) => throwError(error || 'Server error in getProjectArchiviedDocument')))
        .toPromise();
    }

    public downloadArchiviedDocument(archiviedDocument: ArchiviedDocumentInfo): Observable<HttpEvent<Blob>> {
        let authorization = {
            type: "jwt",
            appId: "ST",
            securityValue: this.loginService.getAuthInfoProperties().jwtEncoded
        }

        const headers = new HttpHeaders({ 'Authorization': JSON.stringify(authorization) });
        let url = new UrlMaker()
            .appendBaseUrl(this.proxyApiUrl)
            .appendSegment('api')
            .appendSegment('downloadArchiviedDocument')
            .appendParameter('attachmentID', archiviedDocument.AttachmentID)
            .toString();
        return this.http.request(new HttpRequest( 'GET', url, null, { reportProgress: true, responseType: 'blob', headers: headers }));
    }

    getTableHeader(){
        return {
            table: {
                widths: [ '*', '*', '80%' ],
                body: [
                    [{ text: 'Nr', bold: true, fontSize: 14 }, { text: 'Nazione', bold: true, fontSize: 14 }, { text: 'Testo', bold: true, fontSize: 14 }]
                ],
                layout: 'lightHorizontalLines',
            },
            style: 'tableExample'
        }
    }

    getFunctionalAreaTable(functionalArea: string){
        return {
            table: {
                widths: [ '*' ],
                body: [
                    [{ text: functionalArea, bold: true, fontSize: 14 }]
                ],
                layout: 'lightHorizontalLines',
                style: 'subheaderCell'
            },
            style: 'subheaderText'
        }
    }

    getImprovementDescription(requirements: ImprovementAnalisys[]){
      let description: string = '';
      requirements.filter(req => req.RowType == ProjectDataType.Needs || req.RowType == ProjectDataType.Requirements).forEach(req => {
          description = description ? `${description}\n${req.TextLOC}` : `\n\n${req.TextLOC}`
      })
      return description;
    }




    public async createImprovementPDF(productString: string, date: string, improvements: ProjectImprovementReleases[], functionalAreas: string[]) {
      var docDefinition = {
          pageSize: 'A4',
          pageOrientation: 'portrait',
          pageMargins: [20, 40, 20, 40],

          content: await this.getContentTablesBody(productString, date, improvements, functionalAreas),

          footer: function(currentPage) {
              return [
                { text: currentPage.toString(), alignment: 'center', margins: [5,0,0,0]  }
              ]
          },
          styles: {
              tableExample: {
                borderWidth: 1,
                borderColor: 'black',
              },
              subheaderText: {
                  alignment: 'center',
                  fillColor: '#cbcbcb'
              }
          }
      };
      pdfMake.createPdf(docDefinition).download(`${productString}-relnotes.pdf`);
    }

    async getContentTablesBody(productString: string, date: string, improvements: ProjectImprovementReleases[], functionalAreas: string[]){
      let disclaimer = await this.getDisclaimer();
      let content: any[] = [
          { text: productString, fontSize: 25, bold: true, margin: [ 0,0,0,2 ] },
          { text: `Data publicazione: ${date}`, fontSize: 18, bold: false, margin: [ 0,0,0,2 ] },
          { text: `Area di riferimento: ${(functionalAreas.length == 1 ? functionalAreas[0] : 'Tutte')}`, fontSize: 18, bold: false, margin: [ 0,0,0,20 ] },
          { text: disclaimer, fontSize: 15, bold: false, margin: [ 0,0,0,20 ] },
          { text: 'Lista migliorie:', fontSize: 15, bold: false, margin: [ 0,0,0,5 ] }
      ]
      functionalAreas.forEach((fa, index) => {
          if(index == 0)
              content.push(this.getTableHeader())
          content.push(this.getFunctionalAreaTable(fa))
          content.push(this.getFunctionalAreaDataTable(improvements, fa))
      })
      return content;
    }

    getFunctionalAreaDataTable(improvements: ProjectImprovementReleases[], functionalArea: string){
      let tableBody = {
          table: {
              widths: [ '*', '*', '80%' ],
              body: [],
              layout: 'lightHorizontalLines',
          },
          style: 'tableExample'
      }

      improvements.filter((imp, index) => improvements.indexOf(imp) === index  && (imp.FunctionalAreas.includes(functionalArea) || imp.FunctionalAreasENG.includes(functionalArea))).forEach(imp => {
          tableBody.table.body.push([
              { text: imp.ProjImprID.toString(), bold: false, fontSize: 10 },
              { text: imp.Countries, bold: false, fontSize: 10 },
              [{ text: imp.DescriptionLOC, bold: true, fontSize: 12 },{ text: this.getImprovementDescription(imp.Requirements), bold: false, fontSize: 10 }]
          ])
      })
      return tableBody;
  }


    public async createBugPDF(productString: string, date: string, bugs: ProjectBugReleases[], functionalAreas: string[]) {
        var docDefinition = {
            pageSize: 'A4',
            pageOrientation: 'portrait',
            pageMargins: [20, 40, 20, 40],

            content: await this.getContentBugsTablesBody(productString, date, bugs, functionalAreas),

            footer: function(currentPage) {
                return [
                  { text: currentPage.toString(), alignment: 'center', margins: [5,0,0,0]  }
                ]
            },

            styles: {
                tableExample: {
                  borderWidth: 1,
                  borderColor: 'black',
                },
                subheaderText: {
                    alignment: 'center',
                    fillColor: '#cbcbcb'
                }
            }
        };
        pdfMake.createPdf(docDefinition).download(`${productString}-bugnotes.pdf`);
    }

    async getContentBugsTablesBody(productString: string, date: string, bugs: ProjectBugReleases[], functionalAreas: string[]){
        let disclaimer = await this.getDisclaimer();
        let content: any[] = [
            { text: productString, fontSize: 25, bold: true, margin: [ 0,0,0,2 ] },
            { text: `Data publicazione: ${date}`, fontSize: 18, bold: false, margin: [ 0,0,0,2 ] },
            { text: `Area di riferimento: ${(functionalAreas.length == 1 ? functionalAreas[0] : 'Tutte')}`, fontSize: 18, bold: false, margin: [ 0,0,0,20 ] },
            { text: disclaimer, fontSize: 15, bold: false, margin: [ 0,0,0,20 ] },
            { text: 'Lista Correzioni:', fontSize: 15, bold: false, margin: [ 0,0,0,5 ] }
        ]
        functionalAreas.forEach((fa, index) => {
            if(index == 0)
              content.push(this.getTableHeader())
            content.push(this.getFunctionalAreaTable(fa))
            content.push(this.getFunctionalAreaBugsDataTable(bugs, fa))
        })
        return content;
    }

    getFunctionalAreaBugsDataTable(bugs: ProjectBugReleases[], functionalArea: string){
        let tableBody = {
            table: {
                widths: [ '*', '*', '80%' ],
                body: [],
                layout: 'lightHorizontalLines',
            },
            style: 'tableExample'
        }


        bugs.filter((bug, index) => bugs.indexOf(bug) === index && (bug.FunctionalAreas.includes(functionalArea) || bug.FunctionalAreasENG.includes(functionalArea))).forEach(bug => {
            tableBody.table.body.push([
                { text: bug.BugID.toString(), bold: false, fontSize: 10 },
                { text: bug.Countries, bold: false, fontSize: 10 },
                [{ text: bug.DescriptionLOC, bold: true, fontSize: 12 }, { text: `\n\n${bug.TextLOC}`, bold: false, fontSize: 10 }]
            ])
        })
        return tableBody;
    }
}
